<template>
    <auth-layout>
        <template #topLink>
            <v-btn text color="txtSecondary" class="text-none" :to="{name: 'login'}">
                {{ $t('entrance.login') }}
            </v-btn>
        </template>
        <user-form @success="onSuccess" />
    </auth-layout>
</template>

<script>

import AuthLayout from '@/components/entrance/AuthLayout'
import UserForm from '@/components/entrance/UserForm'

import {mapState} from 'vuex'

export default {
    components: {
        AuthLayout,
        UserForm
    },
    computed: {
        ...mapState(['loadingUser'])
    },
    methods: {
        onSuccess(loaded = false) {
            const vm = this
            if (loaded) {
                vm.$router.push({name: 'confirm-mail'})
            }
        }
    },
    watch: {
        loadingUser(isLoading) {
            if (!isLoading) {
                this.onSuccess(true)
            }
        }
    }
}
</script>
